/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
import React, {useState} from 'react';
import {connect} from 'react-redux';
import {setCurrentProduct} from '../../../../redux/order/order.actions'
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  // CardActions,
  Typography,
  // Grid,
  Divider,
  colors
} from '@material-ui/core';
// import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import { setOrdersStart, setOrdersSuccess, setCurrentOrder, setCurrentItem, setUpdatedOrder} from '../../../../redux/order/order.actions';
import { setLoading, setErrors } from '../../../../redux/other/other.actions';
import {
  loadProduseStart,
  loadMaterialeStart,
  loadOptionaleStart,
  loadCuloriStart,
  loadPreturiTabelareStart,
  loadInformariStart,
  loadIndicatoriStart,
} from '../../../../redux/lookup/lookup.actions';
import { verificaIndicatoriSiActualizeaza } from '../../../../utils/functiiComune';
import { withSnackbar } from 'notistack';
import Loader from 'react-loader-spinner'
import {isFeatureEnabled} from '../../../../config/featureFlags';
import { t } from '../../../../i18n';
import { getLocalizedText } from '../../../../utils/lookupLocale';

const useStyles = makeStyles(theme => ({
  root: {
    background:'#F0F5F4',
    position:'relative'
  },
  menuContainer:{
    display:'flex',
    flexWrap:'nowrap',
    overflowX:'hidden',
    justifyContent:'space-between',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    backgroundColor: colors.blueGrey[50],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow:'inset 0 1px 2px rgba(0,0,0,0.05)',
    minHeight: theme.spacing(6),
    msOverflowStyle:'none',
    scrollbarWidth:'none',
    '&::-webkit-scrollbar':{
      display:'none'
    },
    '& > *:not(:last-child)':{
      marginRight: theme.spacing(1)
    }
  },
  imageContainer: {
    height: 250,
    width: 200,
    margin: '0 auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%',
  },
  icons:{
    with:30,
    height:30
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center'
  },
  statsIcon: {
    color: theme.palette.icon,
    marginRight: theme.spacing(1),
    
  },
  menuButton:{
    flex:'1 1 0',
    minWidth: 0,
    textTransform:'none',
    padding: theme.spacing(0.5, 0.75),
    fontSize:'0.75rem',
    lineHeight:1.2,
    whiteSpace:'normal',
    wordBreak:'break-word',
    textAlign:'center',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    minHeight: theme.spacing(5),
    [theme.breakpoints.down('xs')]:{
      fontSize:'0.7rem',
      padding: theme.spacing(0.5, 0.25)
    }
  },
  menuHidden:{
    visibility:'hidden',
    pointerEvents:'none'
  },
  button: {
    margin: theme.spacing(1),
    width: '150',
    height:'150',
    background:colors.blueGrey[400]
  },
  titlu:{
    color:colors.blueGrey[600]
  },
  input: {
    display: 'none',
  },
  loadingOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 5,
    background: 'rgba(240, 245, 244, 0.92)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1)
  },
  loadingText: {
    color: colors.blueGrey[700],
    fontSize: '0.9rem'
  }
}));

const ProductCard = props => {
  const { className, product, history, setCurrentProduct, setOrdersStart, currentUser, firmeComisionar } = props;
  const classes = useStyles();
  const [isNavigatingToOrders, setIsNavigatingToOrders] = useState(false);
  const shouldRenderMenu = Boolean(product && product.meniu);
  const productText = (field)=> getLocalizedText(product, field);
  let menuItems = [
    {label:t('productCard.menuPresentation'), key:'prezentareUrl'},
    {label:t('productCard.menuPrices'), key:'preturiUrl'},
    {label:t('productCard.menuMeasureInstall'), key:'instructiuniUrl'},
    {label:t('productCard.menuVideo'), key:'videoUrl'}
  ];
  if (product?.cod === 'ex'){
    menuItems = menuItems.filter(item => item.key !== 'preturiUrl' && item.key !== 'instructiuniUrl');
  }
  if (product?.comandaExpozorUrl){
    menuItems.push({label:t('productCard.menuRequestDisplay'), key:'comandaExpozorUrl'});
  }
  const imageContainerStyle = {
    ...(product?.imagewidth && { width: `${product.imagewidth}px` }),
    ...(product?.imageheight && { height: `${product.imageheight}px` })
  };
  //--------------------------------------------------------------------------------------------
  const incarcaComenzi=()=>{
    if (isFeatureEnabled('ordersServerPaging')) {
      return;
    }
    const isComisionar = currentUser?.idFirma?.cfg1 === 'DA'
    const firmeAfiliateIds = (firmeComisionar || [])
      .map(firma => firma?.id)
      .filter(id => id !== null && id !== undefined && id !== '')
    const idFirmeComisionar = firmeAfiliateIds.length > 0
      ? firmeAfiliateIds
      : [currentUser?.idFirma?.id].filter(id => id !== null && id !== undefined && id !== '')
    if (isComisionar) {
      setOrdersStart({
        idFirma: currentUser.idFirma.id,
        idFirmeComisionar,
        isComisionar: true,
        tipProdus:product.cod,
        subTip:product.subTip,
        page:1,
        pageSize:12,
        sort:'id:desc'
      })
      return
    }
    setOrdersStart({idFirma:currentUser.idFirma.id,tipProdus:product.cod,subTip:product.subTip,page:1,pageSize:12,sort:'id:desc'})
  }
  //--------------------------------------------------------------------------------------------
  const produsSelectat=()=>{
    return new Promise((resolve) => {
      setTimeout(async() => {
        setCurrentProduct(product)
        resolve('ok')
      },20) 
    })
  }
  //--------------------------------------------------------------------------------------------
     const handleButComanda = async () => {
     if (isNavigatingToOrders) {
       return;
     }
     try {
       setIsNavigatingToOrders(true);
       document.body.style.cursor = 'wait';
       
       // Nu mai curățăm comenzile aici, le vom curăța doar după ce navigăm
       
       // Executăm toate operațiunile asincrone în paralel
       await Promise.all([
         verificaIndicatoriSiActualizeaza(currentUser.idFirma.id, props),
         produsSelectat()
       ]);
       
       // Navigăm către pagina de comenzi\
       if (product.cod==='ex'){
        history.push('/expozoare');
       }else{
        history.push('/orders');
       }
       
       // DUPĂ navigare, curățăm comenzile și încărcăm datele noi într-o singură operație
       setTimeout(async () => {
         props.setOrdersSuccess([]); // Curățăm comenzile
         await incarcaComenzi(); // Încărcăm imediat comenzile noi
       }, 100);
       
       // Resetăm cursor
       document.body.style.cursor = 'pointer';
     } catch (error) {
       console.error('Eroare:', error);
       props.enqueueSnackbar(t('productCard.orderProcessError'), { 
         variant: 'error',
         autoHideDuration: 3000
       });
       document.body.style.cursor = 'pointer';
       setIsNavigatingToOrders(false);
     }
  }
  //--------------------------------------------------------------------------------------------
  const handleMenuClick=async (key, url)=>{
    if(!url){
      return;
    }
    if (key === 'comandaExpozorUrl'){
      await Promise.all([
        produsSelectat(),
        verificaIndicatoriSiActualizeaza(currentUser.idFirma.id, props)
      ]);
      history.push(url);
      setTimeout(async () => {
        props.setOrdersSuccess([]);
        await incarcaComenzi();
      }, 100);
      return;
    }
    if (key === 'videoUrl'){
      await produsSelectat();
      history.push(url);
      return;
    }
    window.open(url,'_blank','noopener,noreferrer');
  }
  //--------------------------------------------------------------------------------------------
  if (props.loading===false){
    return (
      <Card
        className={clsx(classes.root, className)}
      >
        {isNavigatingToOrders && (
          <div className={classes.loadingOverlay}>
            <Loader
              color="#00BFFF"
              height={45}
              type="Puff"
              width={45}
            />
            <Typography className={classes.loadingText}>
              {t('productCard.loadingOrders')}
            </Typography>
          </div>
        )}
        <CardContent>
          <div className={clsx(classes.menuContainer, {[classes.menuHidden]: !shouldRenderMenu})}>
            {shouldRenderMenu && menuItems.map(item=>(
              <Button
                key={item.key}
                className={classes.menuButton}
                variant="outlined"
                color="primary"
                onClick={()=>handleMenuClick(item.key, productText(item.key))}
                disabled={!productText(item.key) || isNavigatingToOrders}
              >
                {item.label}
              </Button>
            ))}
          </div>
          <div className={classes.imageContainer} style={imageContainerStyle}>
            <Button  onClick={handleButComanda} className={classes.button} disabled={isNavigatingToOrders}>  
              <img
                alt="Product"
                className={classes.image}
                src={product.imageUrl}
              />
            </Button>
          </div>
          <Typography
            align="center"
            gutterBottom
            variant="h4"
            className={classes.titlu}
          >
            {productText('title')}
          </Typography>
          <Typography
            align="center"
            variant="body1"
           
          >
            {productText('description')}
          </Typography>
        </CardContent>
        <Divider />
        {/*<CardActions>
          <Grid
            container
            justify="space-between"
          >
            <Grid
              className={classes.statsItem}
              item
            >
            
              <Typography
                display="inline"
                variant="body2"
              >
               
                <Typography
                  display="inline"
                  variant="body2"
                >
                  <Button
                    className={classes.button}
                    color="secondary"
                    href={product.instructiuniUrl}
                    style={{fontSize:10}}
                    variant="contained"
                  >
                Instructiuni montaj
                  </Button>
                </Typography>
               
                
              
              </Typography>
            </Grid>
            <Grid
              className={classes.statsItem}
              item
            >
            
              <Typography
                display="inline"
                variant="body2"
              >
                <Button
                  className={classes.button}
                  color="secondary"
                  onClick={handleButComanda}
                  variant="contained"
                >
                Comenzi <span style={{color:'#cc0000'}}> {product.cod.toUpperCase()}</span>
                </Button>
              </Typography>
            </Grid>
          </Grid>
        </CardActions>*/}
      </Card>
    );
  }else{
    return (
      <div className="spinner">
        <Loader
          color="#00BFFF"
          height={100}
          type="Puff"
          width={100}
        />
      </div>
    );
  }
};

ProductCard.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object.isRequired
};

const mapStateToProps=state=>({
  currentProduct:state.order.currentProduct,
  currentUser:state.user.currentUser,
  firmeComisionar: state.lookup.firmeComisionar,
  loading:state.other.loading
})

const mapDispatchToProps=dispatch=>({
  setCurrentProduct:product=>dispatch(setCurrentProduct(product)),
  setOrdersStart:(idFirmaAndTipProdus)=>dispatch(setOrdersStart(idFirmaAndTipProdus)),
  setOrdersSuccess:(orders)=>dispatch(setOrdersSuccess(orders)),
  setCurrentOrder:order=>dispatch(setCurrentOrder(order)),
  setLoading:boll=>dispatch(setLoading(boll)),
  setErrors:error=>dispatch(setErrors(error)),
  setCurrentItem:item=>dispatch(setCurrentItem(item)),
  setUpdatedOrder:order=>dispatch(setUpdatedOrder(order)),
  // Adăugăm acțiunile pentru actualizarea nomenclatoarelor
  loadProduseStart: () => dispatch(loadProduseStart()),
  loadMaterialeStart: () => dispatch(loadMaterialeStart()),
  loadOptionaleStart: () => dispatch(loadOptionaleStart()),
  loadCuloriStart: () => dispatch(loadCuloriStart()),
  loadPreturiTabelareStart: () => dispatch(loadPreturiTabelareStart()),
  loadInformariStart: () => dispatch(loadInformariStart()),
  loadIndicatoriStart: () => dispatch(loadIndicatoriStart())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withSnackbar(ProductCard)));
